
export default {
  download: '下載APP',
}
